export { colors, colorsDark } from '@kiips/ui';
export type { ThemeColors } from '@kiips/ui';
